import axios from "axios";
import { QuestionStore } from "@/store/store";
import { API_ERROR_STATUS } from "@/constants/api.constants";
import { SYSTEM_ERRORS } from "@/constants/message.constants";

export const pslClient = axios.create({
  baseURL: process.env.VUE_APP_PSL_API_URL,
  headers: {
    "Content-type": "application/json",
  },
});

// Add interceptor to check when API fail for Broker
pslClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (!QuestionStore.getters("isSelfServeJourney")) {
      if (
        error &&
        error.response &&
        API_ERROR_STATUS.includes(error.response.status)
      ) {
        throw new Error(SYSTEM_ERRORS.errorSessionExpired.errorId);
      }
    }
    return Promise.reject(error);
  }
);
